import { render, staticRenderFns } from "./SetupWizard.vue?vue&type=template&id=3f584047&scoped=true"
import script from "./SetupWizard.vue?vue&type=script&lang=js"
export * from "./SetupWizard.vue?vue&type=script&lang=js"
import style0 from "./SetupWizard.vue?vue&type=style&index=0&id=3f584047&prod&scoped=true&lang=css"
import style1 from "./SetupWizard.vue?vue&type=style&index=1&id=3f584047&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f584047",
  null
  
)

export default component.exports